import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import OrganizationSubscriptionResource from './OrganizationSubscriptionResource';
import OrganizationLogoResource from './OrganizationLogoResource';

export default class OrganizationResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  read(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  update(data, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .patch(data, { url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete() {
    return super
      .delete()
      .then((response) => response)
      .catch((error) => error.response);
  }

  getStat() {
    return super
      .get({ url: `${this.url}/stat` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listGroups(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/groups${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  inviteUser(data, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .post(data, { url: `${this.url}/members${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  assignAdmin(userId, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `${this.url}/admins/${userId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  unassignAdmin(userId, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .delete({ url: `${this.url}/admins/${userId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  listMembers(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/members${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  addMember(userId, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .post({}, { url: `${this.url}/members/${userId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  removeMember(userId, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .delete({ url: `${this.url}/members/${userId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  subscription() {
    return new OrganizationSubscriptionResource(`${this.url}/subscription`);
  }

  logo() {
    return new OrganizationLogoResource(`${this.url}/logo`);
  }
}
